import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import * as ACL from 'domain/restriction';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import LockButton from 'pages/company/WorkspaceRoute/components/LinkedDocumentsPanel/components/LinkedActions/LockButton';
import PrintButton from 'pages/company/WorkspaceRoute/components/LinkedDocumentsPanel/components/LinkedActions/PrintButton';
import DownloadButton from 'pages/company/WorkspaceRoute/components/LinkedDocumentsPanel/components/LinkedActions/DownloadButton';
import ExportButton from 'pages/company/WorkspaceRoute/components/LinkedDocumentsPanel/components/LinkedActions/ExportButton';
import ThreeDotsButton from 'pages/company/WorkspaceRoute/components/LinkedDocumentsPanel/components/LinkedActions/ThreeDotsButton';
import MoveToBundle from 'pages/company/WorkspaceRoute/components/LinkedDocumentsPanel/components/LinkedActions/MoveToBundle';

const mapStateToProps = (state) => ({
  isGranted: ACL.isGranted(state),
});

const LinkedActions = ({ linkID, total, onMoveToCompany, onOpenSendByEmailDialog, moveToBundleOptions }) => {
  const { formatMessage } = useIntl();
  const { isGranted } = useSelector(mapStateToProps);
  const isAccountUser = isGranted(ACL.IS_ACCOUNT);

  return (
    <Box display="flex" alignItems="center">
      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
        {formatMessage(
          {
            id: 'documents.linkedPanel.title.list',
            defaultMessage: `${total} documents`,
          },
          {
            value: total,
          },
        )}
      </Typography>
      <Stack direction="row" spacing={0.25} ml="auto">
        <LockButton linkID={linkID} />
        <Divider orientation="vertical" variant="middle" flexItem sx={{ my: '8px !important' }} />

        {isAccountUser && <MoveToBundle moveToBundleOptions={moveToBundleOptions} />}
        <PrintButton linkID={linkID} />
        <DownloadButton linkID={linkID} />
        <ExportButton linkID={linkID} />
        <ThreeDotsButton
          linkID={linkID}
          onOpenSendByEmailDialog={onOpenSendByEmailDialog}
          onMoveToCompany={onMoveToCompany}
          showMoveToCompany={isAccountUser}
        />
      </Stack>
    </Box>
  );
};

export default LinkedActions;
